import { apiClient } from './client';

// S-H1: Transfer detail interfaces
export interface TransferEvent {
  id: string;
  event_type: string;
  occurred_at: string;
  status_from?: string;
  status_to?: string;
  actor_type?: string;
}

export interface TransferBankAccount {
  institution_name?: string;
  account_name?: string;
  account_type?: string;
  mask?: string;
}

export interface TransferOwner {
  name: string;
  email: string;
}

export interface TransferDetail {
  id: string;
  transfer_type: string; // 'deposit' or 'payout'
  amount_cents: number;
  currency: string;
  status: string;
  rail: string;
  provider: string;
  provider_transfer_id?: string;
  failure_reason?: string;
  memo?: string;
  created_at: string;
  updated_at: string;
  completed_at?: string;
  last_checked_at?: string;
  stale_flag?: boolean;
  stale_reason?: string;
  owner?: TransferOwner;
  bank_account?: TransferBankAccount;
  events?: TransferEvent[];
  withdrawal_request_id?: string;
  metadata?: Record<string, any>; // S-H3: Metadata for multi-leg transfers and other data
}

export const adminTransferEndpoints = {
  // Get transfer detail
  getDetail: (transferId: string) =>
    apiClient.get<TransferDetail>(`/api/admin/transfers/${transferId}`),

  // S-H3: Refresh transfer status from provider
  refreshStatus: (transferId: string) =>
    apiClient.post<{ message: string; transfer: TransferDetail }>(`/api/payments/transfers/${transferId}/refresh`),

  // S-H3: Apply ledger mapping (idempotent)
  applyLedgerMapping: (transferId: string) =>
    apiClient.post<{ message: string; entry_created: boolean }>(`/api/admin/reconciliation/${transferId}/apply_ledger_mapping`),
};
